import { useEffect, useState } from 'react';
import { StocktakeTab } from '../../components/stores/StoresSlice1';
import { apiGet } from '../../lib/api';

export default function MobileStocktake() {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    apiGet('/projects').then(r => setProjects(Array.isArray(r) ? r : (r?.items || r?.projects || []))).catch(() => {});
  }, []);
  return <div className="p-3" data-testid="mobile-stocktake-page"><StocktakeTab compact projects={projects} /></div>;
}
